export default __webpack_public_path__ + "static/logotype-white-4773ec1515b568e2e78422065c78f14f.svg";